export const LDCONSTANTS = Object.freeze({
  ASSETS: "moduleAssetsEnabled",
  PARTS: "partModule",
  PURCHASEORDER: "modulePurchaseOrderEnabled",
  DASHBOARD_ACCESS: "quiqflowDashboardAccess",
  ASSET_DASHBOARD: "assetDashboard",
  WORK_ORDER_DASHBOARD: "workOrderDashboard",
  MAINTENANCE_DASHBOARD: "maintenanceDashboard",
  WORK_ORDER_ACTIVITY: "quiqflowIsChatEnabled",
  MAX_SIGNATURE_COUNT: "quiqflowMaxSignaturesPerUser",
  CHAT_SERVICE_ENABLED: "quiqflowQuiqflowChatServiceEnabled",
});
